export default __webpack_public_path__ + "static/star-4708bd719ac850e807e55099cef02ec3.webp";